import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';
import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const authSlice = createAppSlice({
  name: 'auth',
  initialState,
  reducers,
});

export const { setChannelFeatures, setFeatureFlags, toggleFeatureFlag, loadFeatureFlags } = authSlice.actions;

export default authSlice.reducer;
